/** Algoia Filter menu **/
jQuery(document).ready(function($) {
  // $(".ais-filter-btn").on("click", function(){  
  //   $(this).parents().find('.ais-page').toggleClass("open"); 
  //   $(this).toggleClass('highlight');
  // });
  // $(".ais-facets-close-button").on("click", function(){  
  //   $(this).parents().find('.ais-page').toggleClass("open"); 
  // });
  if( $(window).width() > 768 ){
      $('.ais-facet--header').addClass('active');
      $('.ais-facet--header').next().addClass('add');
    } else {
      $('.ais-facet--header').removeClass('active');
      $('.ais-facet--header').next().removeClass('add');
    } 
    $('.ais-facet--header').click(function(){
      console.log('tab_clicked');
      if( $(this).hasClass('active') ) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
      if( $(this).next().hasClass('add') ) {
        $(this).next().removeClass('add');
      } else {
        $(this).next().addClass('add');
      }
    });
  setTimeout(function(){
    console.log('tab_clicked_ready');
    $('div[class="ais-facet-meta.variant.color_family-container"] li').each(function(){
      var ss = $(this).find('.ais-RefinementList-label').text().split(' ').join('');
      var bg_color = ss.replace(/[0-9]/g, '');
      $(this).find('.ais-RefinementList-label').append('<span class="adding" style="background:' + bg_color + ';"></span>');
    });
    // $('li.ais-Hits-item').each(function(){
    //   if( $(this).find('.ais-hit--price>span').hasClass('ais-hit--price-striked') ) {
    //     $(this).find('.ais-hit--save').removeClass('hide');
    //     var price_d = $(this).find('.ais-hit--price b').text();
    //     var price_dd = price_d.substring(1);
    //     var price_s = $(this).find('.ais-hit--price .ais-hit--price-striked').text();
    //     var price_ss = price_s.substring(1);
    //     var price_r = ( price_dd.trim().replace(/,/g, '') / price_ss.trim().replace(/,/g, '') ) * 100;
    //     var price_rr = ( 100 - price_r.toFixed(0) ) + '%';
    //     $(this).find('.algolia-save').text(price_rr);
    //   }
    // });
    $('body.lord-taylor .ais-facets>div').each(function(){
      $(this).find('.ais-facet--header+div').append('<div class="cus_show show_more">Show More</div><div class="cus_show show_less">Show Less</div>');

      if ( $(this).find('ul li').length <= 7 ) {
          $(this).find('.cus_show').addClass('hide-facet');
        }
      
      $(this).find('.show_more').click(function(){
        $(this).parent().find('.ais-Panel').addClass('more_facet');
        if( $(this).hasClass('hide-facet') ) {
          $(this).removeClass('hide-facet');
          $(this).parent().find('.show_less').removeClass('add');
        } else {
          $(this).addClass('hide-facet');
          $(this).parent().find('.show_less').addClass('add');
        }
      });
      $(this).find('.show_less').click(function(){
        $(this).parent().find('.ais-Panel').removeClass('more_facet');
        if( $(this).hasClass('add') ) {
          $(this).removeClass('add');
          $(this).parent().find('.show_more').removeClass('hide-facet');
        } else {
          $(this).addClass('add');
          $(this).parent().find('.show_more').addClass('hide-facet');
        }
      });
    });  
  }, 3000);  
  setTimeout(function(){
    $('div[class="ais-facet-meta.variant.color_family-container"] li').each(function(){
      $(this).click(function(){
        if( $(this).find('span').hasClass('adding') ){
        } else {
          var ss = $(this).find('.ais-RefinementList-label').text().split(' ').join('');
          var bg_color = ss.replace(/[0-9]/g, '');
          $(this).find('.ais-RefinementList-label').append('<span class="adding" style="background:' + bg_color + ';"></span>');
        }
      });
    });
    $('div[class="ais-facet-meta.variant.color_family-container add"] li').each(function(){
      $(this).click(function(){
        if( $(this).find('span').hasClass('adding') ){
        } else {
          var ss = $(this).find('.ais-RefinementList-label').text().split(' ').join('');
          var bg_color = ss.replace(/[0-9]/g, '');
          $(this).find('.ais-RefinementList-label').append('<span class="adding" style="background:' + bg_color + ';"></span>');
        }
      });
    });
  }, 4000); 
  var key = $('.isp_title_search_term').text();
  $('.ais-stats--nb-results-key').text(key);
  $('.site-header__search-input').click(function(){ 
    $(this).addClass('search_clicked');
  });
  function containsAll(needles, haystack){ 
    for(var i = 0; i < needles.length; i++){
       if($.inArray(needles[i], haystack) == -1) return false;
    }
    return true;
  }
  setInterval(function(){
    $('.ais-Hits-list .ais-Hits-item').each(function(index){
      var counter = $(this).find('.algolia-count_total').text();
      var arr = $(this).find('.algolia-count_tags').text().split(',');
      var my_arr = [];
      for(let j=0; j < arr.length; j++ ){ 
          if (arr[j].indexOf('Size_') >=0){
              var txt = arr[j];
              my_arr.push(txt);
          } 
      }
      var counter_size_O = my_arr.length;
      if (containsAll(['Size_Full', 'Size_Queen'], arr)) {
        counter_size = counter_size_O - 1;
      } else if (containsAll(['Size_Twin', 'Size_Twin XL'], arr)) {
        counter_size = counter_size_O - 1; 
      } else {
        counter_size = counter_size_O;  
      }
      if (counter_size_O <= 0) {
        counter_size = 1;
      }
      var counter_option = $(this).find('.algolia-count_option').text();
      // if (counter && counter_size && $(this).find('.ais-hit--variant_color').hasClass('hide')) {
      //   var counter_result_0 = parseInt(parseInt(counter) / parseInt(counter_size));
      //   var counter_result = counter_result_0 -1;
      //   if (counter_result == 1 && counter_option == 'size') {
      //     counter_result = 0;
      //   }
      //   if (counter_result > 1) {
      //     $(this).find('.ais-hit--variant_color').removeClass('hide');
      //   }
      //   $(this).find('.algolia-count_color').text(counter_result);
      // }
    }); 
  }, 1000);
  
  current_ship();
  function current_ship() {
    setTimeout(function(){
      if ($('.ais-current-refined-values--link:contains("Ready to Ship")').length > 0) {
          $('.ais-ship-btn').addClass('highlight');
      } else {
          $('.ais-ship-btn').removeClass('highlight');
      }
      if ($('.ais-current-refined-values--link:contains("Ships within two weeks")').length > 0) {
          $('.ais-ships-btn').addClass('highlight');
      } else {
          $('.ais-ships-btn').removeClass('highlight');
      }
      if ($('.ais-current-refined-values--link:contains("Ready to Ship")').length > 0 && $('.ais-current-refined-values--link:contains("Ships within two weeks")').length > 0) {
          $('.ais-ships-btn').removeClass('highlight');
          $('.ais-ship-btn').removeClass('highlight');
          $('.ais-view-btn').addClass('highlight');
      } else if ($('.ais-current-refined-values--link:contains("Ready to Ship")').length > 0 || $('.ais-current-refined-values--link:contains("Ships within two weeks")').length > 0) {
          $('.ais-view-btn').removeClass('highlight');
      } else { }
    }, 700);
  }
  
  // $(document).on('click', function (event) {
  //   $('.site-header__search-input').removeClass('search_clicked');
  // });
  $('body').on('click', '.site-header__search-input',  function (event) {
    event.stopPropagation();
    color_number_sort();
    review_rating_sort();
    $('.site-header__search-input').addClass('search_clicked');
  });
  $(document).on('click', '.ais-ship-btn', function(){
    $(this).parents().find('.ais-ClearRefinements-button').trigger('click');  
    $(this).parent().find('.ais-btn:not(.ais-filter-btn)').removeClass('highlight');
    $(this).addClass('highlight');
    $(this).parents().find( ".ais-RefinementList-list li" ).each(function( index ) {
      if ($(this).find('.ais-facet--label:contains("Ready to Ship")').length > 0) {
          $(this).find('.ais-facet--label').trigger('click');
          if ($(window).width() > 767) {
            $(window).scrollTop(0);
          }
      }
    });
    product_number();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-ships-btn', function(){
    $(this).parents().find('.ais-ClearRefinements-button').trigger('click');
    $(this).parent().find('.ais-btn:not(.ais-filter-btn)').removeClass('highlight');
    $(this).addClass('highlight');
    $(this).parents().find( ".ais-RefinementList-list li" ).each(function( index ) {
      if ($(this).find('.ais-facet--label:contains("Ships within two weeks")').length > 0) {
          $(this).find('.ais-facet--label').trigger('click');
          if ($(window).width() > 767) {
            $(window).scrollTop(0);
          }
      }
    });
    product_number();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-view-btn', function(){
    $(this).parents().find('.ais-ClearRefinements-button').trigger('click');
    // $(this).parents().find( ".ais-RefinementList-list li" ).each(function( index ) {
    //   if ($(this).find('.ais-facet--label:contains("Ready to Ship")').length > 0) {
    //       $(this).find('.ais-facet--label').trigger('click');
    //   }
    //   if ($(this).find('.ais-facet--label:contains("Ships within two weeks")').length > 0) {
    //       $(this).find('.ais-facet--label').trigger('click');
    //   } 
    // }); 
    $(this).parent().find('.ais-btn:not(.ais-filter-btn)').removeClass('highlight');
    $(this).addClass('highlight');
    product_number();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-ClearRefinements-button', function(){
    product_number();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-current-refined-values--link', function(){
    product_number();
    current_ship();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-RefinementList-label', function(){
    product_number();
    current_ship();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-RefinementList-item', function(){
    product_number();
    current_ship();
    color_number_sort();
    review_rating_sort();
  });
  $(document).on('click', '.ais-Pagination-item', function(){
    product_number();
    current_ship();
    color_number_sort();
    review_rating_sort();
  });
  
  color_number();
  
  function product_number() {
    if ($(window).width() < 768) {
      setTimeout(function(){
        var result_nb = $('.ais-stats_nb').text();
        if (result_nb == ''){
          $('.nb').text('1');
          $('.nb_txt').text(' product found');
        } else {
          $('.nb').text(result_nb);
          $('.nb_txt').text(' products found');
        }
       }, 500);  
    }
  }
  
  function color_number() {
    setTimeout(function(){
      console.log('Color_length_step');
      $('.ais-Hits-list .ais-Hits-item').each(async function(e){
        var number = e + 1;
        var product_handle1 = $(this).find('.ais-hit.ais-product').data('handle');
        if ($(this).find('.algolia-count_color').text() == '') {
          const product = await jQuery.getJSON('/products/' + product_handle1 + '.js');
          if (product) {
            const colorOption = product.options?.filter(opt => {
              return opt.name === 'Color'
            });
            if (colorOption && colorOption.length) {
              const colorIdx = colorOption?.[0]?.position;
              var color_length = product.options[0].values.length;
              var color_counter_length = color_length - 1;
              var variant_length = product.variants.length;
              var variant_arr = [];
              var colorOptionName = 'option' + colorIdx; 
              for(let j=0; j < variant_length; j++ ){ 
                if (variant_arr.indexOf(product.variants[j][colorOptionName]) === -1 && product.variants[j].available === true) {
                    var text = product.variants[j][colorOptionName];
                    variant_arr.push(text);
                }
              }
               console.log("Product Title: ", product.title + "," + product.id + " || Color Length: " +color_length + " || variant_length:" + variant_arr.length);
              var variant_color_length = variant_arr.length - 1;
              console.log("Final Print--variant_color_length:", variant_color_length);
              if (variant_color_length > 0) {
                if (number === 6) {
                  console.log('found issue');
                }
                //console.log('found multiple colors for ', number, product.handle);
                $(this).find('.ais-hit--variant_color').removeClass('hide');
                $(this).find('.algolia-count_color').text(variant_color_length);
                //console.log("Under If condition:", variant_color_length);
              }
               // $('.ais-Hits-item:nth-child(' + number +') .algolia-count_color').text(variant_color_length);
            }
          }
        }
      });
    }, 3000);
  }

  function color_number_sort() {
    setTimeout(function(){
      console.log('Color_length_step');
       $('.ais-Hits-list .ais-Hits-item').each(async function(e){
        var number = e + 1;
        var product_handle1 = $(this).find('.ais-hit.ais-product').data('handle');
        if ($(this).find('.algolia-count_color').text() == '') {
          const product = await jQuery.getJSON('/products/' + product_handle1 + '.js');
          if (product) {
            const colorOption = product.options?.filter(opt => {
              return opt.name === 'Color'
            });
            if (colorOption && colorOption.length) {
              const colorIdx = colorOption?.[0]?.position;
              var color_length = product.options[0].values.length;
              var color_counter_length = color_length - 1;
              var variant_length = product.variants.length;
              var variant_arr = [];
              var colorOptionName = 'option' + colorIdx; 
              for(let j=0; j < variant_length; j++ ){ 
                if (variant_arr.indexOf(product.variants[j][colorOptionName]) === -1 && product.variants[j].available === true) {
                    var text = product.variants[j][colorOptionName];
                    variant_arr.push(text);
                }
              }
               console.log("Product Title: ", product.title + "," + product.id + " || Color Length: " +color_length + " || variant_length:" + variant_arr.length);
              //console.log('variant_color_length:' + variant_arr.length);
              var variant_color_length = variant_arr.length - 1;
              console.log("Final Print--variant_color_length:", variant_color_length);
              if (variant_color_length > 0) {
                if (number === 6) {
                  console.log('found issue');
                }
                //console.log('found multiple colors for ', number, product.handle);
                $(this).find('.ais-hit--variant_color').removeClass('hide');
                //$('.algolia-count_color').text(variant_color_length);
                $(this).find('.algolia-count_color').text(variant_color_length);
                //console.log("Under If condition:", variant_color_length);
              }
               // $('.ais-Hits-item:nth-child(' + number +') .algolia-count_color').text(variant_color_length);
            }
          }
        }
      });
    }, 3000);
  }
  
  var lastScrollTop = 0;
  $(window).scroll(function(event){
     var st = $(this).scrollTop();
     lastScrollTop = st;
  });
  
  setInterval(function(){
    $('div[class="ais-facet-meta.variant.color_family-container add"] li').each(function(){
      var ss = $(this).find('.ais-RefinementList-label').text().split(' ').join('');
      var bg_color = ss.replace(/[0-9]/g, '');
      if (!$(this).find('.adding').length){
        $(this).find('.ais-RefinementList-label').append('<span class="adding" style="background:' + bg_color + ';"></span>');
      }
    });
    if ($('.ais-clear-refinements-container .ais-Panel:first-child').hasClass('ais-Panel--noRefinement')) {
      $('.ais-ship-btn').removeClass('highlight');
      $('.ais-ships-btn').removeClass('highlight');
    }
    if ($('.ais-current-refined-values--item').length != 0) {
      $('.ais-view-btn').removeClass('highlight');
    }
    if ($('.ais-facet--label:contains("Ships within two weeks")').length > 0) {
      $('.ais-ships-btn').css('pointer-events','auto');
    } else {
      $('.ais-ships-btn').css('pointer-events','none');
    }
    if ($('.ais-facet--label:contains("Ready to Ship")').length > 0) {
      $('.ais-ship-btn').css('pointer-events','auto');
    } else {
      $('.ais-ship-btn').css('pointer-events','none');
    }
  }, 1000);
  setTimeout(function(){
    const urlParams = new URLSearchParams(window.location.search);
    var number = $('.ais-stats_nb').text();
    if (window.location.search != '' && urlParams.get('q') != null) {
      var search__key = urlParams.get('q').replace('%20',' ');
      console.log('search__key:' + search__key);
      $('.algolia_title_search_term').text(search__key);
      $('.site-header__search-input').val(search__key);
    }
    $('.nb').text(number);
    if ($('.ais-stats_nb').text() == ''){
      $('.template--search .algolia_title_results_for').before('<span class="nb"></span><span class="nb_txt"> products found for </span>');
      $('.nb').text('1');
    } else {
      $('.template--search .algolia_title_results_for').before('<span class="nb"></span><span class="nb_txt"> products found for </span>');
      $('.nb').text(number);
    }   
    if ($(window).width() < 768) {
      if ($('.ais-stats_nb').text() == ''){
        $('.template-collection .algolia_title_results_for').before('<span class="nb"></span><span class="nb_txt"> product found</span>');
        $('.nb').text('1');
      } else {
        $('.template-collection .algolia_title_results_for').before('<span class="nb"></span><span class="nb_txt"> products found</span>');
        $('.nb').text(number);
      }  
    } 
  }, 1000); 
  
  /**Show Products on focus**/
  var resizeEvent = window.document.createEvent('UIEvents'); 
  resizeEvent.initUIEvent('resize', true, false, window, 0); 
  window.dispatchEvent(resizeEvent);
  $(window).trigger('resize');
  $(".site-header__search-input.custom").click(function(){
    console.log('First Click');
    $(".algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete").addClass('add');
    $('.search-modal__close-button').removeClass('hide');
  });
  $('.search-modal__close-button').on('click',function(e){
    console.log('close');
    $(".algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete").removeClass('add');
    $('.search-modal__close-button').addClass('hide');
    $('.algolia-autocomplete').hide();
    $('.site-header__search-input').val('');
    $('.template--search .site-header__search-input').removeClass('is-filled');
  });
  $('body').not('.algolia-autocomplete').click(function(){ 
    $(".algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete").removeClass('add');
    $('.search-modal__close-button').addClass('hide');
    $('.algolia-autocomplete').hide();
  });
  $('.fancybox-overlay').not('.fancybox-wrap').click(function(e){ 
    e.preventDefault();
  });
  if ($(window).width() < 768) {
    $(".site-header__search-input").click(function(){
      console.log('Mobile First Click');
      $('.app-data').removeClass('hide');
      $('.cus-data').addClass('hide');
      // if ($(this).val().length > 0) {
      //   $('.app-data').removeClass('hide');
      //   $('.cus-data').addClass('hide');
      // } else {
      //   $('.app-data').addClass('hide');
      //   $('.cus-data').removeClass('hide');
      // }
      /* Search Bar, 03/30, Guo */
      // $(".algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete").addClass('add');
      /* End */
      $('.search-modal__close-button').removeClass('hide');
      $('.search-bar__submit').addClass('open');
    });
    $('.search-modal__close-button').on('click',function(e){
      console.log('close');
      $(".algolia-autocomplete").removeClass('add');
      $('.search-modal__close-button').addClass('hide');
      $('.algolia-autocomplete').hide();
      $('.search-bar__submit').removeClass('open');
      $('.site-header__search-input').val('');
      $('.template--search .site-header__search-input').removeClass('is-filled');
    });
    $('body').not('.algolia-autocomplete').click(function(){ 
      $(".algolia-autocomplete").removeClass('add');
      $('.search-modal__close-button').addClass('hide');
      $('.algolia-autocomplete').hide();
    });
    $('.ais-ClearRefinements-button').click(function(){
      setTimeout(function(){
        location.reload();
      }, 500); 
    });
    $('.template--search .site-header__search-input').keyup(function(e){
      if(e.keyCode == 13) {
          var linkk_1 = $('.site-header__search-input.is-filled').val();
          var linkkk_1 = 'https://www.chichome.com/search?q=' + linkk_1;
          window.location.href = linkkk_1;
      }
   });
  } else {
    $(".site-header__search-input").click(function(){
      console.log('desk First Click');
      
      $('.app-data').removeClass('hide');
      $('.cus-data').addClass('hide');
      /* Search Bar, 03/30, Guo */
      // $(".algolia-autocomplete").addClass('add');
      // $(".algolia-autocomplete+.algolia-autocomplete").removeClass('add');
      // $(".algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete").removeClass('add');
      // $(".algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete+.algolia-autocomplete").removeClass('add');
      /* End */
      $('.search-modal__close-button').removeClass('hide');
      $('.search-bar__submit').addClass('open');
    });
    $('.search-modal__close-button').on('click',function(e){
      console.log('close');
      $(".algolia-autocomplete").removeClass('add');
      $('.search-modal__close-button').addClass('hide');
      $('.algolia-autocomplete').hide();
      $('.search-bar__submit').removeClass('open');
      $('.site-header__search-input').val('');
      $('.template--search .site-header__search-input').removeClass('is-filled');
    });
    $('body').not('.algolia-autocomplete').click(function(){ 
      $(".algolia-autocomplete").removeClass('add');
      $('.search-modal__close-button').addClass('hide');
      $('.algolia-autocomplete').hide();
    });
    $('.ais-ClearRefinements-button').click(function(){
      setTimeout(function(){
        location.reload();
      }, 500); 
    });
  }
  $(document).on('click','.modal-overlay',function(e){
    $('.algolia-autocomplete').hide();
  });
  $('.algolia-autocomplete').click(function(event){
    event.stopPropagation();
    console.log("autocomplete section click");
  });
  
  $(".site-header__search-input").on('keyup', function(event){
    console.log('KeyPress');
    $('.app-data').removeClass('hide');
    $('.cus-data').addClass('hide');
    
  });
  $('.template--search .site-header__search-input').keyup(function(e){
      if(e.keyCode == 13) {
          $(this).trigger("enterKey");
      }
  });
  $('.address-list__item').each(function(){
    var modal_id = $(this).find('.link[data-action="open-modal"]').attr('aria-controls');
    $(this).find('.link[data-action="open-modal"]').click(function(){
        $('#' + modal_id).attr('aria-hidden','false');
    });
  });
  var address_id = $('h1+button[data-action="open-modal"]').attr('aria-controls');
  $('h1+button[data-action="open-modal"]').click(function(){
    $('#' + address_id).attr('aria-hidden','false');
  });
  setTimeout(function(){
    var activeMainCollection = jQuery('.site-nav--is-megamenu.is-focused a').text().toLowerCase();
    jQuery('.suggestion-collection-group').hide();
    if(activeMainCollection == "men"){
      jQuery('.suggestion-collection-group[data-parent="men"]').show();
    }else if(activeMainCollection == "kids"){
      jQuery('.suggestion-collection-group[data-parent="kids"]').show();
    }else if(activeMainCollection == "home"){
      jQuery('.suggestion-collection-group[data-parent="home"]').show();
    }else{
      jQuery('.suggestion-collection-group[data-parent="women"]').show();
    }
  },1200);
  setTimeout(function(){
    var activeMainCollection = jQuery('.site-nav--is-megamenu.is-focused a').text().toLowerCase();
    jQuery('.suggestion-collection-group').hide();
    if(activeMainCollection == "men"){
      jQuery('.suggestion-collection-group[data-parent="men"]').show();
    }else if(activeMainCollection == "kids"){
      jQuery('.suggestion-collection-group[data-parent="kids"]').show();
    }else if(activeMainCollection == "home"){
      jQuery('.suggestion-collection-group[data-parent="home"]').show();
    }else{
      jQuery('.suggestion-collection-group[data-parent="women"]').show();
    }
  },2200);
  
  /**** PCP Review Rating ****/
  review_rating();
  $(document).on('click', '.ais-Pagination-link', function(){
    review_rating_sort();
    color_number_sort();
  });
  /* SortBy Change Event */
  $(document).on('change', '.ais-SortBy-select', function(){
    review_rating_sort();
    color_number_sort();
  });
  function review_rating() {
     setTimeout(function(){
       $('.ais-Hits-list .ais-Hits-item').each(function(e){
        if ($(this).find('.ais-rating--hide').text() != '') {
          var ar_h = $(this).find('.ais-rating--hide').text();
          // var arr_1 = ar_h.split('","');
          // let ar = '';
          // $(this).find('.ais-hit--title').addClass('ais-rating');
          // for( let i=0; i<arr_1.length; i++  ) {
          //   if (arr_1[i].includes('value')) {
          //       ar = parseFloat(arr_1[i].split('value":"')[1].replace('{','').replace('}','').replace('"','')).toFixed(1);
          //       break;
          //   }
          // }
          var arc = ($(this).find('.ais-rating--counter-hide').text()).trim();
          //$(this).find('.ais-rating').text(ar_h);
          if(arc != 0){
            $(this).find('.ais-rating--counter').text('(' + arc + ')');
          }
          if(ar_h != 0){
            $(this).find(".my-rating").starRating({
              initialRating: ar_h,
              strokeColor: 'transparent',
              strokeWidth: 10,
              starSize: 15,
              emptyColor: 'lightgray',
              hoverColor: 'lightgray',
              activeColor: 'black',
              disableAfterRate: false,
              useGradient: false,
              readOnly: true
            });
        }
        }
      });
    }, 2600);  
  }
  function review_rating_sort() {
     setTimeout(function(){
       $('.ais-Hits-list .ais-Hits-item').each(function(e){
        if ($(this).find('.ais-rating--hide').text() != '') {
          var ar_h = $(this).find('.ais-rating--hide').text();
          var arc = ($(this).find('.ais-rating--counter-hide').text()).trim();
          //$(this).find('.ais-rating').text(ar_h);
          if(arc != 0){
            $(this).find('.ais-rating--counter').text('('+arc+')');
          }
          if(ar_h != 0){
            $(this).find(".my-rating").starRating({
              initialRating: ar_h,
              strokeColor: 'transparent',
              strokeWidth: 10,
              starSize: 15,
              emptyColor: 'lightgray',
              hoverColor: 'lightgray',
              activeColor: 'black',
              disableAfterRate: false,
              useGradient: false,
              readOnly: true
            });
          }
        }
      }); 
    }, 1000);     
  }
$('.mobile-facet-reset').click(function(){
      setTimeout(function(){
        location.reload();
      }, 500); 
});	 

});

/* Quick view Height, 0407, Guo */
scroll_height();
$(window).scroll(function() {
    scroll_height();
}).scroll();
function scroll_height() {
    var $myDiv = $('.ais-hit--picture').prop('scrollHeight');
    $('.quick_add').css('top',$myDiv-45 + 'px');
}
/* End */

/**Mobile Facets Filter**/
$(document).on('click','.refine-by',function(e){
  $(this).parents('.ais-page').find('.ais-facets').toggleClass('ais-facets__shown');
})
$(document).on('click','.ais-facets-apply-button',function(e){
  $(this).parents('.ais-facets').removeClass('ais-facets__shown');
})
$(document).on('click','.ais-facets-close-button',function(e){
  $(this).parents('.ais-facets').removeClass('ais-facets__shown');
})
$(document).on('click','.ais-facets-close-button',function(e){
   $('body').attr('style', 'overflow-y: auto !important');
})



